export enum DeleteResponseType {
  Deleted,
  Prevented,
  PreventedCanContinue
}
